export default "<p>cgv works!</p>\n"